import email from "./email";
import url from "./url";
import lowerCase from "./lowerCase";
import upperCase from "./upperCase";

export default [email, url, lowerCase, upperCase];
